import api from "../../../shared/api/client";

export async function getTargetReport(level, dc, id, year, month) {
  const { data } = await api.get(`/target/${level}/${dc}/${id}/${year}/${month}`);
  return data;
}

export async function savePersonnelTarget(body) {
  const { data } = await api.post("/target/personnel-target", body);
  return data;
}

export async function getPersonnelTargets(personnelId) {
  const { data } = await api.get(`/target/personnel-target/${personnelId}`);
  return data;
}

export async function deletePersonnelTarget(uid) {
  const { data } = await api.delete(`/target/personnel-target/${uid}`);
  return data;
}

export async function getSuggestedTargets(personnelId, manufacturerId, productGroupId, year, month) {
  const { data } = await api.get(
    `/target/suggested-targets/${personnelId}/${manufacturerId}/${productGroupId}/${year}/${month}`,
  );
  return data;
}

export async function getTargetCoverage(year, month, calendarType) {
  const { data } = await api.get(`/target/coverage/${year}/${month}`, {
    params: calendarType ? { calendar_type: calendarType } : undefined,
  });
  return data;
}

export async function getManagerTargetDistribution(year, month, calendarType) {
  const { data } = await api.get(`/target/distribution/${year}/${month}`, {
    params: calendarType ? { calendar_type: calendarType } : undefined,
  });
  return data;
}

export async function getMonthCustomerTargets(personnelId, year, month) {
  const { data } = await api.get(`/target/month-customer-target/${personnelId}`, {
    params: {
      ...(year ? { year } : {}),
      ...(month ? { month } : {}),
    },
  });
  return data;
}

export async function saveMonthCustomerTarget(body) {
  const { data } = await api.put("/target/month-customer-target", body);
  return data;
}

export async function getPersonnelTargetByUid(uid) {
  const { data } = await api.get(`/target/personnel-target/edit/${uid}`);
  return data;
}

export async function updatePersonnelTarget(uid, body) {
  const { data } = await api.put(`/target/personnel-target/${uid}`, body);
  return data;
}
